import React from "react";

import { SkeletonBox } from "~/components/skeleton/box";
import { HealthStateValue } from "~/models/dto";
import { cx } from "~/tools/class-variance";
import type { Record } from "~/tools/record";

import { healthStateToColorToken } from "../../../common/functions";
import { Api } from "../../../common/openapi";

export type HealthStateCircleSize = "small" | "medium" | "large";

export interface HealthStateCircleProps {
	/**
	 * Renders a skeleton when `undefined`
	 */
	state: undefined | Api.HealthStateValue | HealthStateValue;
	size?: HealthStateCircleSize;
	className?: string;
	css?: never;
	tw?: never;
}

const sizeMap = {
	small: cx("size-2"),
	medium: cx("size-3"),
	large: cx("size-4"),
} satisfies Record<HealthStateCircleSize>;

export const HealthStateCircle: React.FC<HealthStateCircleProps> = ({ className, state, size = "large" }) => (
	<SkeletonBox
		className={cx(
			"shrink-0 rounded-full",
			state === HealthStateValue.Uninitialized || state === Api.HealthStateValue.UNINITIALIZED
				? "border border-(--health-state-color)"
				: "bg-(--health-state-color)",
			sizeMap[size],
			className,
		)}
		data-testid={`sts-state-circle-${state?.toString() ?? "skeleton"}`}
		style={
			{
				"--health-state-color": `var(${healthStateToColorToken(state)})`,
			} as React.CSSProperties
		}
		when={state}
	/>
);
